module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/460.a34ef958.png";